import axios from "axios";
import { IQuestion, ITopic, ITopicWithStats } from "./types";
import { IUserAuth } from "./userSlice";

axios.defaults.xsrfHeaderName = "X-CSRFToken";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.withCredentials = true;

export const getTopic = (topicId: number) =>
  axios.get(`/api/topic/${topicId}/`).then((res) => res.data as ITopic);

export const getTopics = () =>
  axios.get("/api/").then((res) => res.data.topics as ITopicWithStats[]);

export const getMe = () =>
  axios.post("/api/auth/me/", {}).then((res) => res.data as IUserAuth);

export const login = (authData: any) =>
  axios
    .post("/api/auth/tg-login/", authData)
    .then((res) => res.data as IUserAuth);

export const logout = () =>
  axios.post("/api/auth/tg-logout/", {}).then((res) => res.data as IUserAuth);

export const recordAnswer = (
  questionId: number,
  answer: number,
  isCorrect: boolean
) =>
  axios.post("/api/record-answer/", {
    question_id: questionId,
    answer,
    is_correct: isCorrect,
  });

export const getNextWorstQuestion = () =>
  axios
    .post("/api/next-question/worst/", {})
    .then((res) => res.data.question as IQuestion);
